export const UPDATE_DEPARTMENTLIST = 'updateDepartmentList';